import { render, staticRenderFns } from "./FormIdpExamRegister.vue?vue&type=template&id=072bbb70&scoped=true"
import script from "./FormIdpExamRegister.vue?vue&type=script&lang=js"
export * from "./FormIdpExamRegister.vue?vue&type=script&lang=js"
import style0 from "./FormIdpExamRegister.vue?vue&type=style&index=0&id=072bbb70&prod&scoped=true&lang=css"
import style1 from "./FormIdpExamRegister.vue?vue&type=style&index=1&id=072bbb70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072bbb70",
  null
  
)

export default component.exports